<template>
<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_17951_139580" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
<rect y="0.046875" width="24" height="24" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_17951_139580)">
<path d="M16.25 20.7719V17.7719H13.25V16.2719H16.25V13.2719H17.75V16.2719H20.75V17.7719H17.75V20.7719H16.25ZM3.25 17.7969V16.2969H4.75V17.7969H3.25ZM6.75 17.7969V16.2969H11.2963C11.2654 16.5602 11.2542 16.811 11.2625 17.0491C11.2708 17.2873 11.2904 17.5365 11.3212 17.7969H6.75ZM3.25 13.7969V12.2969H4.75V13.7969H3.25ZM6.75 13.7969V12.2969H13.727C13.4398 12.4994 13.1773 12.7256 12.9395 12.9756C12.7017 13.2256 12.4853 13.4994 12.2905 13.7969H6.75ZM3.25 9.79688V8.29688H4.75V9.79688H3.25ZM6.75 9.79688V8.29688H18.75V9.79688H6.75ZM3.25 5.79688V4.29688H4.75V5.79688H3.25ZM6.75 5.79688V4.29688H18.75V5.79688H6.75Z" fill="#1E264C"/>
</g>
</svg>

</template>
